'use strict';

common.View.create('website::partials.Menu', {
    onDOMLoad() {
        this.initMobileMenu();
    },

    initMobileMenu() {
        let hamburger = $('.hamburger');

        // Namespaced off+on so repeated View inits (this partial renders once
        // per menu on the page) leave exactly one set of handlers behind.
        hamburger.off('.mobileMenu');

        hamburger.on('mousedown.mobileMenu', (event) => {
            // Check if the button pressed is the left mouse button
            if (event.button === 0) {
                this.initMobileMenuClick(hamburger);
            }
        });
        hamburger.on('touchstart.mobileMenu', () => this.initMobileMenuClick(hamburger));
        hamburger.on('keydown.mobileMenu', () => this.initMobileMenuClick(hamburger, true));

        window.removeEventListener('mobile-menu-closed', this.menuClosedEvent);
        window.addEventListener('mobile-menu-closed', this.menuClosedEvent);
    },

    initMobileMenuClick(hamburger, usingKeyboard = false)
    {
        // Re-entrancy guard. `aria-expanded` mirrors the live open state and
        // is cleared the instant the menu closes — unlike `is-active`, which
        // lingers ~350ms for the hamburger's close animation. Guarding on
        // `is-active` swallowed every reopen click during that window.
        if (hamburger.attr('aria-expanded') === 'true') {
            return;
        }

        // A close animation may still be waiting to strip `is-active`; cancel
        // it so a fast reopen keeps the hamburger in its active (X) state.
        let closeTimer = hamburger.data('mobileMenuCloseTimer');
        if (closeTimer) {
            clearTimeout(closeTimer);
            hamburger.removeData('mobileMenuCloseTimer');
        }

        window.dispatchEvent(new CustomEvent('mobile-menu-update', {
            bubbles: true,
            detail: {
                open: true,
                usingKeyboard: usingKeyboard,
            },
        }));

        hamburger.addClass('is-active');
        hamburger.attr('aria-expanded', 'true');
        $('body').addClass('overflow-hidden');

        return false;
    },

    menuClosedEvent() {
        let hamburger = $('.hamburger');

        $('body').removeClass('overflow-hidden');

        // Clear the open state straight away so the menu can be reopened
        // immediately; `is-active` lingers only for the close animation.
        hamburger.attr('aria-expanded', 'false');

        let pending = hamburger.data('mobileMenuCloseTimer');
        if (pending) {
            clearTimeout(pending);
        }

        hamburger.data('mobileMenuCloseTimer', setTimeout(() => {
            hamburger.removeClass('is-active');
            hamburger.removeData('mobileMenuCloseTimer');
        }, 350));
    },
});
